<div class="carousel-container">
  <!-- <h3 class="carousel-title">{{ title }}</h3> -->
  <!-- Track des images -->
  <div class="carousel-track" #track >
    @for (attach of attachs; track attach.id; let i = $index) {
      <div class="carousel-item">
        <div class="image-wrapper" [class.no-thumb]="isThumbBroken(attach)" (click)="onImageClick(attach.id!)" >
          @if (attach.id === 0) {
            <mat-spinner diameter="40"></mat-spinner>
          } @else {
            <img [src]="attach.thumbnailLocalUrl" [alt]="attach.name" loading="lazy" (error)="onThumbError(attach)"/>
          }
          @if (getIcon(attach); as icon) {
            <div class="icon-item" [innerHTML]="icon"></div>
          }
        </div>
        <div class="item-info">
          <div class="info-row">
            <input  type="text"  class="name-input"  [value]="baseOf(attach.name)" (blur)="updateName(i, $event , extOf(attach.name))" placeholder="Nom de l'image" (click)="$event.stopPropagation()" [disabled]="!canEdit || isSealed(attach)">
            @if (extOf(attach.name); as ext) {
              <span >.{{ ext }}</span>
            }
            <div class="sequence-controls">
              <button  type="button" class="seq-btn"  (click)="moveSequence(attach, -1); $event.stopPropagation()" [disabled]="!canEdit || i === 0" title="Déplacer vers la gauche">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"> <path d="M15 18l-6-6 6-6"/> </svg>
              </button>
              <span class="seq-value">{{ attach.seq ?? i + 1 }}</span>
              <button  type="button" class="seq-btn"  (click)="moveSequence(attach, +1); $event.stopPropagation()" [disabled]="!canEdit || i === attachs.length - 1" title="Déplacer vers la droite">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"> <path d="M9 18l6-6-6-6"/> </svg>
              </button>
            </div>
          </div>
          <div class="info-row"></div>
          <div class="info-row actions-row">
            <label class="checkbox-label" [class.disabled]="!canEdit || isSealed(attach)">
              <input  type="checkbox"  [checked]="isDefaultImage(attach)" (change)="setAsDefaultImage(i, attach,  $event)" (click)="$event.stopPropagation()" [disabled]="!canEdit || isSealed(attach)">
              <span>Image par défaut</span>
            </label>
            <span class="item-id">#{{ attach.id }}</span>
            <button [disabled]="$safeNavigationMigration(attach.contenttype?.includes('youtube'))"  type="button" class="custom-icon-button primary"  (click)="download(i, attach)" title="Télécharger"><mat-icon>download</mat-icon></button>

            <!-- Pièce scellée : PAS de corbeille du tout (le serveur refuserait le geste), un cadenas à sa place. -->
            @if (isSealed(attach)) {
              <mat-icon class="sealed-lock" title="Document scellé : ni modification ni suppression">lock</mat-icon>
            } @else {
              <button  class="custom-icon-button error"  (click)="deleteImage(i, attach)" title="Supprimer l'image" [disabled]="!canEdit"><mat-icon>delete</mat-icon></button>
            }

            <!-- <button  type="button" class="delete-btn"  (click)="deleteImage(i, attach)" title="Supprimer l'image"> <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"> <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/> </svg> </button> -->
          </div>
        </div>
      </div>
    }
  </div>
</div>
